// logger.js
const isProd = process.env.NODE_ENV === 'production';

// Create a console wrapper
export const logger = {
  log: (...args: any[]) => {
    if (!isProd) console.log(...args);
  },
  warn: (...args: any[]) => {
    if (!isProd) console.warn(...args);
  },
  error: (...args: any[]) => {
    // Always log errors, even in production
    console.error(...args);
  },
  info: (...args: any[]) => {
    if (!isProd) console.info(...args);
  },
  debug: (...args: any[]) => {
    if (!isProd) console.debug(...args);
  }
};

// Optional: Override console methods globally
export const setupGlobalLogger = () => {
  if (isProd) {
    console.log = () => {};
    console.warn = () => {};
    console.info = () => {};
    console.debug = () => {};
    // Preserve error logging
    // console.error remains unchanged
  }
};